import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { TrustMarquee } from "./components/site/TrustMarquee";
import { WhatWeBuy } from "./components/site/WhatWeBuy";
import { PriceCTA } from "./components/site/PriceCTA";
import { HowItWorks } from "./components/site/HowItWorks";
import { BulkScrap } from "./components/site/BulkScrap";
import { WhyScrapmans } from "./components/site/WhyScrapmans";
import { Reviews } from "./components/site/Reviews";
import { LocationSection } from "./components/site/LocationSection";
import { FinalCTA } from "./components/site/FinalCTA";
import { MobileBar } from "./components/site/MobileBar";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import SellerPolicy from "./pages/SellerPolicy";
import Accessibility from "./pages/Accessibility";

const Home = () => (
  <ReactLenis root options={{ lerp: 0.1, duration: 1.2 }}>
    <div className="relative bg-white min-h-screen">
      <Header />
      <main>
        <Hero />
        <TrustMarquee />
        <WhatWeBuy />
        <PriceCTA />
        <HowItWorks />
        <BulkScrap />
        <WhyScrapmans />
        <Reviews />
        <LocationSection />
        <FinalCTA />
      </main>
      <MobileBar />
    </div>
  </ReactLenis>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/scrap-seller-policy" element={<SellerPolicy />} />
        <Route path="/accessibility" element={<Accessibility />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
